/* global filter_obj, history */

const $ = jQuery.noConflict();
import {
    initSVGBtns,
} from '@js/common/customFunctions.js';

/* ------------------------------ Script on ready ------------------------------ */
$(document).ready(function() {
    /************* Event FILTER - START *****************/
    // $('.post-ajax-filter form.listing-filter-form').on('submit', function(event) {
    $('.post-ajax-filter form.listing-filter-form').on('submit', function(event) {
        event.preventDefault();

        let industry = [];
        let topic = [];
        let type = [];

        $('.post-ajax-filter .lg-filter-selected-list').empty();

        $('.post-ajax-filter form.listing-filter-form input[name="industry"]:checked').each(function() {
            industry.push($(this).val());
            const industry_label = $(this).closest('li').find('label').data('label');
            $('.post-ajax-filter .lg-filter-selected-list').append(
                '<button class="lg-selected industry-selected no-btn" data-slug="industry_' + $(this).val() + '"><em class="close-icon"></em>' + industry_label + '</button>',
            );
        });

        $('.post-ajax-filter form.listing-filter-form input[name="topic"]:checked').each(function() {
            topic.push($(this).val());
            const topic_label = $(this).closest('li').find('label').data('label');
            $('.post-ajax-filter .lg-filter-selected-list').append(
                '<button class="lg-selected topic-selected no-btn" data-slug="topic_' + $(this).val() + '"><em class="close-icon"></em>' + topic_label + '</button>',
            );
        });

        $('.post-ajax-filter form.listing-filter-form input[name="type"]:checked').each(function() {
            type.push($(this).val());
            const type_label = $(this).closest('li').find('label').data('label');
            $('.post-ajax-filter .lg-filter-selected-list').append(
                '<button class="lg-selected type-selected no-btn" data-slug="type_' + $(this).val() + '"><em class="close-icon"></em>' + type_label + '</button>',
            );
        });

        const pager = $('.post-ajax-filter form.listing-filter-form .pager').val();
        const posts_per_page = $('.post-ajax-filter form.listing-filter-form input[name="posts_per_page"]').val();
        const search_keyword = $('.post-ajax-filter form.listing-filter-form input[name="search_text"]').val();
        const lg_industry_select = $('.post-ajax-filter form.listing-filter-form input[name="lg_industry_select"]').val();
        const lg_topic_select = $('.post-ajax-filter form.listing-filter-form input[name="lg_topic_select"]').val();
        const lg_type_select = $('.post-ajax-filter form.listing-filter-form input[name="lg_type_select"]').val();
        const sort_value = $('.post-ajax-filter form.listing-filter-form .filter-order').val();

        // overwrite arrays with CSV strings (same logic, no redeclare)
        industry = industry.join(',');
        topic = topic.join(',');
        type = type.join(',');

        post_filter_data(
            pager,
            posts_per_page,
            search_keyword,
            sort_value,
            industry,
            lg_industry_select,
            topic,
            lg_topic_select,
            type,
            lg_type_select,
        );
		
        modify_post_filter_url(pager, search_keyword, sort_value, industry, topic, type);

        initSVGBtns();
    });

    //     event.preventDefault();

    //     var industry = [];
    //     var topic = [];
    //     var type = [];

    //     $('.post-ajax-filter .lg-filter-selected-list').empty();

    //     // Handle Event Type filters
    //     $('.post-ajax-filter form.listing-filter-form input[name="industry"]:checked').each(function() {
    //         industry.push($(this).val());
    //         const industry_label = $(this).closest('li').find('label').data('label'); // Get data-label from the label
    //         $('.post-ajax-filter .lg-filter-selected-list').append(
    //             '<button class="lg-selected industry-selected no-btn" data-slug="industry_' + $(this).val() + '"><em class="close-icon"></em>' + industry_label + '</button>',
    //         );
    //     });

    //     $('.post-ajax-filter form.listing-filter-form input[name="topic"]:checked').each(function() {
    //         topic.push($(this).val());
    //         const topic_label = $(this).closest('li').find('label').data('label'); // Get data-label from the label
    //         $('.post-ajax-filter .lg-filter-selected-list').append(
    //             '<button class="lg-selected topic-selected no-btn" data-slug="topic_' + $(this).val() + '"><em class="close-icon"></em>' + topic_label + '</button>',
    //         );
    //     });

    //     $('.post-ajax-filter form.listing-filter-form input[name="type"]:checked').each(function() {
    //         type.push($(this).val());
    //         const type_label = $(this).closest('li').find('label').data('label'); // Get data-label from the label
    //         $('.post-ajax-filter .lg-filter-selected-list').append(
    //             '<button class="lg-selected type-selected no-btn" data-slug="type_' + $(this).val() + '"><em class="close-icon"></em>' + type_label + '</button>',
    //         );
    //     });

    //     const pager = $('.post-ajax-filter form.listing-filter-form .pager').val();
    //     const posts_per_page = $('.post-ajax-filter form.listing-filter-form input[name="posts_per_page"]').val();
    //     const search_keyword = $('.post-ajax-filter form.listing-filter-form input[name="search_text"]').val();
    //     const lg_industry_select = $('.post-ajax-filter form.listing-filter-form input[name="lg_industry_select"]').val();
    //     const lg_topic_select = $('.post-ajax-filter form.listing-filter-form input[name="lg_topic_select"]').val();
    //     const lg_type_select = $('.post-ajax-filter form.listing-filter-form input[name="lg_type_select"]').val();
    //     const sort_value = $('.post-ajax-filter form.listing-filter-form .filter-order').val();

    //     // Get selected filters as comma-separated strings
    //     var industry = $('.post-ajax-filter form.listing-filter-form input[name="industry"]:checked')
    //         .map(function() {
    //             return this.value;
    //         }).get().join(',');

    //     var topic = $('.post-ajax-filter form.listing-filter-form input[name="topic"]:checked')
    //         .map(function() {
    //             return this.value;
    //         }).get().join(',');

    //     var type = $('.post-ajax-filter form.listing-filter-form input[name="type"]:checked')
    //         .map(function() {
    //             return this.value;
    //         }).get().join(',');

    //     //  modify_post_filter_url(pager, search_keyword, sort_value, industry, topic, type, product );

    //     post_filter_data(pager, posts_per_page, search_keyword, sort_value, industry, lg_industry_select, topic, lg_topic_select, type, lg_type_select);

    //     initSVGBtns();
    // });
});

$(document).on('change keydown', '.post-ajax-filter .search-text', function(e) {
    $('.post-ajax-filter .pager').val(1);
});

$(document).on('click', '.post-ajax-filter .icon-search-2', function(e) {
    e.preventDefault();
    $('.post-ajax-filter .pager').val(1);
    $('.post-ajax-filter form.listing-filter-form').submit();
});

$(document).on('click', '.post-ajax-filter .lg-filter-selected-list .lg-selected', function() {
    const fid = $(this).data('slug');
    $('.post-ajax-filter #' + fid).prop('checked', false);
    $(this).remove();
    $('.post-ajax-filter .pager').val(1);
    $('.post-ajax-filter .listing-filter-form').submit();
});

// Reset filter
$('.post-ajax-filter .reset-filter').click(function(e) {
    e.preventDefault();

    // Reset the 'paged' input to 1 (default page)
    $('.post-ajax-filter form.listing-filter-form .pager').val(1);
    $('.post-ajax-filter .listing-filter-form input[name="search_text"]').val('');
    $('.post-ajax-filter .listing-filter-form select[name="filter_order"] option:first').prop('selected', true);
    $('.post-ajax-filter .listing-filter-form input[type="checkbox"]').prop('checked', false);
    $('.post-ajax-filter form.listing-filter-form').submit();
});

// Category filter
$('.post-ajax-filter form.listing-filter-form .cat-filter, .post-ajax-filter form.listing-filter-form .filter-order').change(function() {
    $('.post-ajax-filter form.listing-filter-form .pager').val(1);
    $('.post-ajax-filter form.listing-filter-form').submit();
});

function post_filter_data(pager, posts_per_page, search_keyword, sort_value, industry, lg_industry_select, topic, lg_topic_select, type, lg_type_select) {
    const listing_view = $('.post-ajax-filter form.listing-filter-form input[name="listing_view"]').val();
    const term_id = $('.post-ajax-filter form.listing-filter-form input[name="term_id"]').val();
    const pagination = $('.post-ajax-filter .pagination');
    $.ajax({
        type: 'POST',
        dataType: 'json',
        url: filter_obj.ajax_url, // Ensure correct variable name
        data: {
            action: 'fetch_resoruce_post_list',
            security: filter_obj.nonce, // Pass the nonce
            pager: pager,
            posts_per_page: posts_per_page,
            search_keyword: search_keyword,
            industry: industry,
            lg_industry_select: lg_industry_select,
            topic: topic,
            lg_topic_select: lg_topic_select,
            type: type,
            lg_type_select: lg_type_select,
            sort_value: sort_value,
            term_id: term_id,
            listing_view: listing_view,
        },
        beforeSend: function() {
            const elemHei = $('.post-ajax-filter .lg-grid-area').outerHeight();
            $('.post-ajax-filter .lg-grid-area').css('min-height', elemHei + 'px');
            $('.post-ajax-filter .filter-load-more').show();
            pagination.hide();
            $('.post-ajax-filter .lg-grid-main-row').hide();
        },
        success: function(response) {
            $('.post-ajax-filter .filter-load-more').hide();
            // $('.post-ajax-filter .lg-grid-main-row').html(response.data).hide().show();
            pagination.show();

            if (response.pagination && response.pagination.trim() !== '') {
                pagination.html(response.pagination).show();
            } else {
                pagination.empty().hide();
            }

            /* Animation */
            const $grid = $('.post-ajax-filter .lg-grid-main-row');
            $grid.html(response.data).hide();

            const $items = $grid.find('.lg-grid-col').css({
                opacity: 0,
                transform: 'translateY(30px)',
            });

            $grid.fadeIn(300, function() {
                $items.each(function(i) {
                    const $item = $(this);
                    setTimeout(function() {
                        $item.css({
                            opacity: 1,
                            transform: 'translateY(0)',
                        });
                    }, i * 200);
                });
            });
            /* Animation End */

            if ($('.post-ajax-filter .lg-grid-col .no-result').length > 0) {
                $('.post-ajax-filter .lg-filter-area').addClass('no-result-found');
            } else {
                $('.post-ajax-filter .lg-filter-area').removeClass('no-result-found');
            }

            /* Equal Height */
            if ($('.post-ajax-filter form.listing-filter-form').length) {
                setTimeout(function() {
                    $('.post-ajax-filter .lg-grid-area').css('min-height', 'auto');
                }, 500);
            }

            initSVGBtns();

            if (response.total_pages) {
                $('.post-ajax-filter form.listing-filter-form input[name="max_pages"]').val(response.total_pages);
            }

            if (response.pager) {
                $('.post-ajax-filter form.listing-filter-form .pager').val(response.pager);
            }

            if (response.showing) {
                $('.post-ajax-filter form.listing-filter-form .showing-result').text(response.showing);
            }
            const currentPageUrl = $('.post-ajax-filter form.listing-filter-form input[name="current_page_url"]').val();

            if (term_id) {
                $('.post-ajax-filter a.page-numbers').attr('href', 'javascript:void(0);');
                $('.post-ajax-filter .next').attr('href', 'javascript:void(0);');
                $('.post-ajax-filter .prev').attr('href', 'javascript:void(0);');
            } else {
                $('.post-ajax-filter .pagination a.page-numbers:not(.prev,.next)').each(function() {
                    const pageNumber = parseInt($(this).text());
                    $(this).attr('href', currentPageUrl + '?pager=' + pageNumber);
                });

                $('.post-ajax-filter .pagination a.page-numbers.prev:not(.disabled)').each(function() {
                    const previousPage = response.pager - 1;
                    $(this).attr('href', currentPageUrl + '?pager=' + previousPage);
                });

                $('.post-ajax-filter .pagination a.page-numbers.next:not(.disabled)').each(function() {
                    const nextPage = parseInt(response.pager, 10) + 1;
                    $(this).attr('href', currentPageUrl + '?pager=' + nextPage);
                });
            }
        },
        error: function(error) {
            // console.log('AJAX error:', error);
        },
    });
}

function modify_post_filter_url(pager, search_keyword, sort_value, industry, topic, type) {

    let query_string = '';
    const current_page_url = $('.post-ajax-filter form.listing-filter-form input[name="current_page_url"]').val();
    // console.log(current_page_url);
    query_string += 'pager=' + pager;


    if (industry !== '' && typeof industry !== 'undefined') {
        query_string += '&industry=' + industry;
    }
    if (topic !== '' && typeof topic !== 'undefined') {
        query_string += '&topic=' + topic;
    }
    if (type !== '' && typeof type !== 'undefined') {
        query_string += '&type=' + type;
    }
    if (search_keyword !== '' && typeof search_keyword !== 'undefined') {
        query_string += '&search_text=' + search_keyword;
    }

    if (sort_value !== '' && typeof sort_value !== 'undefined') {
        query_string += '&filter_order=' + sort_value;
    }

    // Determine if a separator is needed
    const separator = current_page_url.includes('?') ? '&' : '?';
    const updated_url = current_page_url + '' + separator + query_string;

    // Update the browser URL without refreshing the page
    history.pushState(null, null, updated_url);

    // Update the canonical link in the head section
    let canonicalLink = document.querySelector('link[rel="canonical"]');

    // If a canonical link exists, update its href attribute, otherwise, create a new one
    if (canonicalLink) {
        canonicalLink.setAttribute('href', updated_url);
    } else {
        canonicalLink = document.createElement('link');
        canonicalLink.setAttribute('rel', 'canonical');
        canonicalLink.setAttribute('href', updated_url);
        document.head.appendChild(canonicalLink);
    }
}




/* ------------------------------ Script on ready ------------------------------ */
jQuery(document).ready(function($) {
    /************* Event FILTER - START *****************/
    // $('.press-release-listing form.listing-filter-form').on('submit', function(event) {
    //     event.preventDefault();
    //     var year = [];

    //     $('.press-release-listing .lg-filter-selected-list').empty();

    //     // Handle Event Type filters
    //     $('.press-release-listing form.listing-filter-form input[name="year"]:checked').each(function() {
    //         year.push($(this).val());
    //         const year_label = $(this).closest('li').find('label').data('label'); // Get data-label from the label
    //         $('.press-release-listing .lg-filter-selected-list').append(
    //             '<button class="lg-selected year-selected" data-slug="year_' + $(this).val() + '"><em class="close-icon"></em>' + year_label + '</button>',
    //         );
    //     });

    //     const pager = $('.press-release-listing form.listing-filter-form #pager').val();
    //     const posts_per_page = $('.press-release-listing form.listing-filter-form input[name="posts_per_page"]').val();
    //     const search_keyword = $('.press-release-listing form.listing-filter-form input[name="search_text"]').val();
    //     const lg_year_select = $('.press-release-listing form.listing-filter-form input[name="lg_year_select"]').val();
    //     const sort_value = $('.press-release-listing form.listing-filter-form .filter-order').val();

    //     // Get selected filters as comma-separated strings
    //     var year = $('.press-release-listing form.listing-filter-form input[name="year"]:checked')
    //         .map(function() {
    //             return this.value;
    //         }).get().join(',');

    //     // modify_press_releases_filter_url(pager, search_keyword, sort_value, year );

    //     press_releases_filter_data(pager, posts_per_page, search_keyword, sort_value, year, lg_year_select);
    // });

    $('.press-release-listing form.listing-filter-form').on('submit', function(event) {
        event.preventDefault();

        let year = [];

        $('.press-release-listing .lg-filter-selected-list').empty();

        $('.press-release-listing form.listing-filter-form input[name="year"]:checked').each(function() {
            year.push($(this).val());
            const year_label = $(this).closest('li').find('label').data('label');
            $('.press-release-listing .lg-filter-selected-list').append(
                '<button class="lg-selected year-selected" data-slug="year_' + $(this).val() + '"><em class="close-icon"></em>' + year_label + '</button>',
            );
        });

        const pager = $('.press-release-listing form.listing-filter-form #pager').val();
        const posts_per_page = $('.press-release-listing form.listing-filter-form input[name="posts_per_page"]').val();
        const search_keyword = $('.press-release-listing form.listing-filter-form input[name="search_text"]').val();
        const lg_year_select = $('.press-release-listing form.listing-filter-form input[name="lg_year_select"]').val();
        const sort_value = $('.press-release-listing form.listing-filter-form .filter-order').val();

        // same logic, no redeclare
        year = year.join(',');

        press_releases_filter_data(
            pager,
            posts_per_page,
            search_keyword,
            sort_value,
            year,
            lg_year_select,
        );

        // modify_press_releases_filter_url(pager, search_keyword, sort_value, year)
    });

});

$(document).on('change keydown', '.press-release-listing #search_text', function(e) {
    $('.press-release-listing #pager').val(1);
});

$(document).on('click', '.press-release-listing .icon-search', function(e) {
    e.preventDefault();
    $('.press-release-listing #pager').val(1);
    $('.press-release-listing form.listing-filter-form').submit();
});


$(document).on('click', '.lg-filter-selected-list .lg-selected', function() {
    const fid = $(this).data('slug');
    $('#' + fid).prop('checked', false);
    $(this).remove();
    $('.press-release-listing #pager').val(1);
    $('.listing-filter-form').submit();
});

// Category filter
$('.press-release-listing form.listing-filter-form .cat-filter').change(function() {
    $('.press-release-listing form.listing-filter-form #pager').val(1);
    $('.press-release-listing .prl-item').remove();
    $('.press-release-listing form.listing-filter-form').submit();
});

$(document).on('click', '.filter-load-more', function(e) {
    e.preventDefault();

    const pager = parseInt($(this).data('current-page')) + 1;
    $('.press-release-listing #pager').val(pager);
    $('.press-release-listing form.listing-filter-form').submit();
});


function press_releases_filter_data(pager, posts_per_page, search_keyword, sort_value, year, lg_year_select) {
    const press_listing_view = $('.press-release-listing form.listing-filter-form input[name="listing_view"]').val();
    const view = $('.press-release-listing form.listing-filter-form input[name="view"]').val();
    const post_type = $('.press-release-listing form.listing-filter-form input[name="post_type"]').val();
    const lg_type_select = $('.press-release-listing form.listing-filter-form input[name="lg_type_select"]').val();
    $.ajax({
        type: 'POST',
        dataType: 'json',
        url: filter_obj.ajax_url, // Ensure correct variable name
        data: {
            action: 'fetch_press_releases_post_list',
            security: filter_obj.nonce, // Pass the nonce
            pager: pager,
            posts_per_page: posts_per_page,
            search_keyword: search_keyword,
            year: year,
            lg_year_select: lg_year_select,
            sort_value: sort_value,
            listing_view: press_listing_view,
            view: view,
            post_type: post_type,
            lg_type_select: lg_type_select,
        },
        beforeSend: function() {
            //  const elemHei = $('.prl-right').outerHeight();
            //  $('.press-release-listing .prl-right').css('min-height', elemHei + 'px');
            $('.press-release-listing .filter-loader').show();
            $('.press-release-listing .filter-load-more').hide();
        },
        success: function(response) {
            $('.press-release-listing .filter-loader').hide();
            // $('.prl-right').html(response.data).hide().show();
            // $('.pagination').show();
            // $('.pagination').html(response.pagination);

            if (response.has_more) {
                $('.press-release-listing .filter-load-more').data('current-page', response.pager).show();
            } else {
                $('.press-release-listing .filter-load-more').parent().hide();
            }

            if (response.total_pages > 1) {
                $('.press-release-listing .pagination').show();
            }

            /* Animation */
            const $grid = $('.prl-list');
            let $newItems;

            if (pager === 1) {
                $grid.html(response.data);
                $newItems = $grid.find('.prl-item');
            } else {
                $newItems = $(response.data);
                $grid.append($newItems);
            }

            /* Prepare animation state ONLY for new items */
            $newItems.css({
                opacity: 0,
                transform: 'translateY(30px)',
            });

            /* Animate new items */
            const offset = $grid.find('.prl-item').length - $newItems.length;

            $newItems.each(function(i) {
                setTimeout(() => {
                    $(this).css({
                        opacity: 1,
                        transform: 'translateY(0)',
                        transition: 'all 0.5s ease',
                    });
                }, (offset + i) * 120);
            });
            /* Animation End */


            /* Equal Height */
            // if ($('.press-release-listing form.listing-filter-form').length) {
            //     setTimeout(function() {
            //         $('.prl-right').css('min-height', 'auto');
            //     }, 500);
            // }
            /* Equal Height */

            if (response.total_pages) {
                $('.press-release-listing form.listing-filter-form input[name="max_pages"]').val(response.total_pages);
            }

            if (response.pager) {
                $('.press-release-listing form.listing-filter-form #pager').val(response.pager);
            }

            if (response.showing) {
                $('.press-release-listing form.listing-filter-form .showing-result').text(response.showing);
            }
            const currentPageUrl = $('.press-release-listing form.listing-filter-form input[name="current_page_url"]').val();

            $('.pagination a.page-numbers:not(.prev,.next)').each(function() {
                const pageNumber = parseInt($(this).text());
                $(this).attr('href', currentPageUrl + '?pager=' + pageNumber);
            });

            $('.pagination a.page-numbers.prev:not(.disabled)').each(function() {
                const previousPage = response.pager - 1;
                $(this).attr('href', currentPageUrl + '?pager=' + previousPage);
            });

            $('.pagination a.page-numbers.next:not(.disabled)').each(function() {
                const nextPage = parseInt(response.pager, 10) + 1;
                $(this).attr('href', currentPageUrl + '?pager=' + nextPage);
            });
        },
        error: function(error) {
            // console.log('AJAX error:', error);
        },
    });
}

// function modify_press_releases_filter_url(pager, search_keyword, sort_value, year) {

//     let query_string = '';
//     const current_page_url = $('.press-release-listing form.listing-filter-form input[name="current_page_url"]').val();
//     // console.log(current_page_url);
//     query_string += 'pager=' + pager;


//     if (year != '' && typeof year != 'undefined') {
//         query_string += '&post_year=' + year;
//     }

//     if (search_keyword != '' && typeof search_keyword != 'undefined') {
//         query_string += '&search_text=' + search_keyword;
//     }

//     // Determine if a separator is needed
//     const separator = current_page_url.includes('?') ? '&' : '?';
//     const updated_url = current_page_url + '' + separator + query_string;

//     // Update the browser URL without refreshing the page
//     history.pushState(null, null, updated_url);

//     // Update the canonical link in the head section
//     let canonicalLink = document.querySelector('link[rel="canonical"]');

//     // If a canonical link exists, update its href attribute, otherwise, create a new one
//     if (canonicalLink) {
//         canonicalLink.setAttribute('href', updated_url);
//     } else {
//         canonicalLink = document.createElement('link');
//         canonicalLink.setAttribute('rel', 'canonical');
//         canonicalLink.setAttribute('href', updated_url);
//         document.head.appendChild(canonicalLink);
//     }
// }